<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="parkLotForm" (ngSubmit)="updateCallerSettings()">
    <div class="page-content" onsip-grid-placement-shelf>
      <div class="first-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.PARKING_LOT_MUSIC" | translate }}</div>
          <mat-form-field
            appearance="outline"
            onsip-form-field-flush-outline
            onsip-hide-subscript-wrapper
          >
            <mat-select formControlName="musicSourceId">
              @for (musicSource of musicSources$ | async; track musicSource) {
              <mat-option [value]="musicSource.musicSourceId">
                {{ musicSource.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button
            mat-button
            color="primary"
            type="button"
            class="add-item-btn"
            (click)="createMusicSource()"
          >
            <mat-icon>add</mat-icon>
            <span> {{ "ONSIP_I18N.ADD_MUSIC_SOURCE" | translate }}</span>
          </button>
        </section>
        <section class="with-mat-form-field with-field-grid">
          <div class="mat-body-1 title-with-field-grid m-b-12">
            {{ "ONSIP_I18N.PARKING_LOT_MANUAL_RETURN_BTN" | translate }}
          </div>
          <div class="field-grid-block">
            <div class="filed-grid">
              <mat-form-field appearance="outline">
                <mat-select formControlName="manualReturnDtmf">
                  @for (btn of manualReturnBtns; track btn) {
                  <mat-option [value]="btn">
                    {{ btn ? btn : ("ONSIP_I18N.NONE" | translate) }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </section>
      </div>
      <div class="second-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">
            {{ "ONSIP_I18N.PARKING_LOT_AUTO_RETURN" | translate }}
          </div>
          <mat-form-field appearance="outline">
            <mat-select formControlName="autoReturnTimeout">
              @for (time of autoReturnTimeout; track time) {
              <mat-option [value]="time"> {{ time }} seconds </mat-option>
              }
            </mat-select>
            <mat-error>{{
              getGenericRequiredError(parkLotForm.controls.autoReturnTimeout, "Field")
            }}</mat-error>
          </mat-form-field>
        </section>
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12 failover-address">
            {{ "ONSIP_I18N.FAILOVER_ADDRESS" | translate }}
            <mat-icon
              class="failover-address-tooltip"
              [matTooltip]="'ONSIP_I18N.FAILOVER_ADDRESS_TOOLTIP_TEXT' | translate"
              matTooltipClass="onsip-tooltip-background"
              matTooltipPosition="above"
            >
              help_outline
            </mat-icon>
          </div>
          <onsip-address-autocomplete
            formControlName="returnAddress"
            placeholder="Search for a Failover"
            [errorMessage]="getGenericRequiredError(parkLotForm.controls.returnAddress, 'Field')"
          >
          </onsip-address-autocomplete>
        </section>
      </div>
    </div>
    <div class="page-view-controls">
      <button mat-button color="primary" class="cancel" type="button" (click)="cancel()">
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      <button type="submit" mat-flat-button color="primary">
        {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
